import { useContext } from 'react'

import { BuyContext } from '@Components/BuyButton/context'

export const useBuyContext = () => {
  const ctx = useContext(BuyContext)
  if (!ctx) {
    throw new Error('Missing BuyContext.Provider')
  }
  return ctx
}
